<template>
  <!-- 外面的快捷选项 只有3个 昨天 今天  明天 -->
  <el-date-picker
    v-model="timeDate"
    type="daterange"
    align="right"
    unlink-panels
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :picker-options="pickerOptions"
    :on-pick="onPick"
    :clearable="clearable"
    v-bind="$attrs"
    format="yyyy-MM-dd"
    value-format="yyyy-MM-dd"
    v-on="$listeners"
    @change="onDateChange"
  />
</template>

<script>
import { getFutureDaysRange, getYesterdayRange, getLastSevenDaysRange, getWeekDateRange, getCurrentDateRange } from '@/utils/date'

export default {
  name: 'BaseDatePickerRange',
  props: {
    // [开始日期，结束日期]
    value: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: (time) => {
        return time.getTime() > Date.now()
      }
    },
    clearable: {
      type: Boolean,
      default: false
    },
    beginTime: {
      type: String,
      default: ''
    },
    endTime: {
      type: String,
      default: ''
    },
    // 快捷选项默认
    shortcutsLayout: {
      type: Array,
      default: () => ['today', 'lastDay', '7day', '30day', 'week', 'lastWeek', 'month', 'lastMonth']
    }
  },
  data () {
    return {
      timeDate: [],
      today: {
        text: '今天',
        onClick: (picker) => {
          const range = getCurrentDateRange()
          picker.$emit('pick', range)
        }
      },
      lastDay: {
        text: '昨天',
        onClick: (picker) => {
          const range = getYesterdayRange()
          picker.$emit('pick', range)
        }
      },
      '7day': {
        text: '过去7天',
        onClick: (picker) => {
          const range = getLastSevenDaysRange()
          picker.$emit('pick', range)
        }
      },
      '30day': {
        text: '过去30天',
        onClick: (picker) => {
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
          picker.$emit('pick', [start, end])
        }
      },
      week: {
        text: '本周',
        onClick: (picker) => {
          const range = getWeekDateRange()
          console.log('range', range)
          picker.$emit('pick', range)
        }
      },
      lastWeek: {
        text: '上周',
        onClick: (picker) => {
          const dataValue = new Date()
          const year = dataValue.getFullYear()
          const month = dataValue.getMonth() + 1
          const day = dataValue.getDate()
          let thisWeekStart // 本周周一的时间
          if (dataValue.getDay() === 0) {
            // 周天的情况；
            thisWeekStart = new Date(year + '/' + month + '/' + day).getTime() - (dataValue.getDay() + 6) * 86400000
          } else {
            thisWeekStart = new Date(year + '/' + month + '/' + day).getTime() - (dataValue.getDay() - 1) * 86400000
          }
          const prevWeekStart = thisWeekStart - 7 * 86400000 // 上周周一的时间
          const prevWeekEnd = thisWeekStart - 1 * 86400000 // 上周周日的时间
          const start = new Date(prevWeekStart) // 开始时间
          const end = new Date(prevWeekEnd) // 结束时间
          picker.$emit('pick', [start, end])
        }
      },
      month: {
        text: '本月',
        onClick: (picker) => {
          const end = new Date()
          const start = new Date()
          start.setDate(1)
          picker.$emit('pick', [start, end])
        }
      },
      lastMonth: {
        text: '上月',
        onClick: (picker) => {
          function gettimeStart () {
            const nowdays = new Date()
            let year = nowdays.getFullYear()
            let month = nowdays.getMonth()
            if (month === 0) {
              month = 12
              year = year - 1
            }
            if (month < 10) {
              month = '0' + month
            }
            let firstDayOfPreMonth = year + '-' + month + '-' + '01'
            firstDayOfPreMonth = firstDayOfPreMonth.toString()
            return new Date(firstDayOfPreMonth)
          }
          function gettimeEnd () {
            const nowdays = new Date()
            let year = nowdays.getFullYear()
            let month = nowdays.getMonth()
            if (month === 0) {
              month = 12
              year = year - 1
            }
            if (month < 10) {
              month = '0' + month
            }
            const lastDay = new Date(year, month, 0)
            let lastDayOfPreMonth = year + '-' + month + '-' + lastDay.getDate()
            lastDayOfPreMonth = lastDayOfPreMonth.toString()
            return new Date(lastDayOfPreMonth)
          }
          const end = gettimeEnd()
          const start = gettimeStart()
          picker.$emit('pick', [start, end])
        }
      },
      lastYear: {
        text: '今年至今',
        onClick: (picker) => {
          function gettimeStart () {
            const today = new Date() // 创建当前日期对象
            today.setMonth(0) // 将月份设置为1（因为 JavaScript 中月份从0开始计数）
            today.setDate(1) // 将日期设置为1
            return new Date(today)
          }
          function gettimeEnd () {
            return new Date() 
          }
          const end = gettimeEnd()
          const start = gettimeStart()
          picker.$emit('pick', [start, end])
        }
      },
      last: {
        text: '至今',
        onClick: (picker) => {
          function gettimeStart () {
            return new Date('2022-01-01')
          }
          function gettimeEnd () {
            return new Date()
          }
          const end = gettimeEnd()
          const start = gettimeStart()
          picker.$emit('pick', [start, end])
        }
      },
      tomorrow: {
        text: '明天',
        onClick: (picker) => {
          const range = getFutureDaysRange(1)
          picker.$emit('pick', range)
        }
      }
    }
  },
  computed: {
    // 时间快捷选项
    shortcuts () {
      const shortcuts = this.shortcutsLayout.map(key => this[key])
      return shortcuts
    },
    pickerOptions () {
      return {
        disabledDate: this.disabledDate,
        shortcuts: this.shortcuts.length ? this.shortcuts : false
      }
    }
  },
  watch: {
    value: {
      handler: function (value) {
        this.timeDate = value
      },
      deep: true,
      immediate: true
    },
    timeDate: {
      handler: function (timeDate) {
        const value = timeDate || []
        this.$emit('input', value)
        this.$emit('update:beginTime', value[0] || '')
        this.$emit('update:endTime', value[1] || '')
      },
      deep: true
    }
  },
  methods: {
    /**
     * @description 选中日期后会执行的回调，
     */
    onPick (timeDate) {
      console.log('onPick', timeDate)
    },
    /**
     * @description date change事件
     */
    onDateChange (timeDate) {
      this.$emit('change', timeDate,this)
    },
    /**
     * 设置禁用状态
     * @param {date} time 时间参数
     * @param {int} type 0为开始，1为结束
     */
    getDateValue (start, text) {
      if (text === '本周') {
        const time = start.getDay()
        if (time) {
          return time
        } else {
          return 7
        }
      } else if (text === '上周') {
        const arr = []
        const time = start.getDay()
        if (time) {
          arr[0] = 7 + time
          arr[1] = time
          return arr
        } else {
          arr[0] = 14
          arr[1] = 7
          return arr
        }
      } else if (text === '上月') {
        const arr = []
        const time = start.getDate()
        arr[0] = new Date(start.getFullYear(), start.getMonth() + 1, 1)
        arr[1] = time
        return arr
      }
    }
    // disabledDate (time, type) {
    //   // 结束日期
    //   if (type) {
    //     return time.getTime() < new Date(this.begin).getTime() - 28800000 || time.getTime() > new Date().getTime()
    //   } else {
    //     if (this.end) {
    //       return time.getTime() > new Date(this.end).getTime()
    //     }
    //     return time.getTime() > new Date().getTime()
    //   }
    // }
  }
}
</script>
